import { render, staticRenderFns } from "./regularidade-fiscal.vue?vue&type=template&id=49dd0e3f&scoped=true"
import script from "./regularidade-fiscal.vue?vue&type=script&lang=js"
export * from "./regularidade-fiscal.vue?vue&type=script&lang=js"
import style0 from "./regularidade-fiscal.vue?vue&type=style&index=0&id=49dd0e3f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49dd0e3f",
  null
  
)

export default component.exports